<template>
  <div id="page-business-add">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <vs-input
            class="w-full mt-4"
            :label="$t('businesses.manager')"
            v-model="businessData.userId"
            name="userId"
            v-validate="'required'"
            placeholder="id"
          />
          <span class="text-danger text-sm" v-show="errors.has('userId')">{{ errors.first('userId') }}</span>

          <vs-input
            class="w-full mt-4"
            :label="$t('businesses.website')"
            v-model="businessData.website"
            name="website"
          />
          <span class="text-danger text-sm" v-show="errors.has('website')">{{
            errors.first('website')
          }}</span>
        </div>
        <div class="vx-col w-full md:w-1/2">
          <div class="w-full mt-4">
            <label class="vs-input--label">{{ $t('businesses.plans.plan') }}</label>
            <v-select
              v-model="businessData.plan"
              :clearable="false"
              :options="planOptions"
              :reduce="option => option.value"
              v-validate="'required'"
              name="plan"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <span class="text-danger text-sm" v-show="errors.has('plan')">{{ errors.first('plan') }}</span>
          </div>
          <!--Expiration Date -->
          <div class="w-full mt-4">
            <label class="vs-input--label">{{ $t('businesses.expiration_date') }}</label>

            <date-picker type="datetime" v-model="businessData.expirationDate" element="expirationDate" />
            <vs-input
              name="expirationDate"
              id="expirationDate"
              :value="
                businessData.expirationDate
                  ? $moment(businessData.expirationDate)
                      .locale($vs.rtl ? 'fa' : 'en')
                      .format('HH:mm dddd, DD MMMM YYYY')
                  : ''
              "
              v-validate="'required'"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('expirationDate')">{{
              errors.first('expirationDate')
            }}</span>
          </div>
        </div>
      </div>
      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="addBusiness" :disabled="!validateForm">{{
              $t('forms.add')
            }}</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Store Module
import moduleBusiness from '@/store/business/moduleBusiness.js'

export default {
  name: 'BusinessAdd',
  data() {
    return {
      businessData: {},
      plansEnum: []
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    },
    planOptions() {
      return this.$store.getters['enum/selectOptions']('BusinessPlan', 'businesses.plans')
    }
  },
  methods: {
    addBusiness() {
      if (!this.validateForm) return
      this.$store
        .dispatch('business/createBusiness', this.businessData)
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: this.$t('forms.successfully_created')
          })
          this.$router.push({ name: 'system-business-view', params: { id: res.data.id } })
        })
    }
  },
  created() {
    // Register Module Business Module
    if (!moduleBusiness.isRegistered) {
      this.$store.registerModule('business', moduleBusiness)
      moduleBusiness.isRegistered = true
    }
  }
}
</script>
